import PropTypes from 'prop-types';

export const BtnPausarModerador = ({ estado, setEstado, isAdminMod, isCategory }) => {
    if ((isAdminMod || isCategory) && (estado === "pausado" || estado === "en_revision")) {
        return null;
    }

    if (isAdminMod || isCategory) {
        return (
            <button
                disabled={estado === "pausado" || estado === "en_revision"}
                name="en_revision"
                onClick={setEstado}
                className="btn background-rojo-megatone waves-effect btn-sm waves-light m-r-10"
            >
                Pausar
            </button>
        )
    }

    return null;
}
BtnPausarModerador.propTypes = {
    estado: PropTypes.string,
    isAdminMod: PropTypes.bool,
    isCategory: PropTypes.bool,
    setEstado: PropTypes.func,
}